export default "__VITE_ASSET__C_R6Hldr__"